const BLACKLIST_URLS = ['/lead-management/developments']

export const isBlacklisted = (url: string) => {
  return BLACKLIST_URLS.some((blacklistedUrl) => url.includes(blacklistedUrl))
}
